import React from 'react';

function Main(props) {
    return (
        <div>All by gidromodules</div>
    );
}

export default Main;